/**
 * External dependencies
 */
import { get } from 'lodash';

/**
 * Internal dependencies
 */
import { mergeEdits } from 'state/utils';


export default (state, id) => {
	const logs = get(state, ['dashboardLayouts', 'edits', id], null);

	if (!logs) {
		return null;
	}

	return mergeEdits(...logs);
};
